'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/prop-types, no-unused-vars */
// XXX: The prop type checking bugs out for some reason partially.


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VisibilityToggles = function VisibilityToggles(_ref) {
  var columns = _ref.columns,
      onToggleColumn = _ref.onToggleColumn,
      isVisible = _ref.isVisible,
      _ref$props = _ref.props,
      props = _ref$props === undefined ? {
    container: {},
    label: {},
    value: {},
    toggle: {}
  } : _ref$props;
  return _react2.default.createElement(
    'div',
    _extends({
      className: 'visibility-container'
    }, props.container),
    columns.filter(function (column) {
      return column.header && column.header.label;
    }).map(function (column, columnIndex) {
      var key = 'visibility-toggle-' + columnIndex;

      return _react2.default.createElement(
        'label',
        _extends({
          className: 'visibility-label',
          htmlFor: key
        }, props.label, {
          key: key
        }),
        _react2.default.createElement(
          'span',
          _extends({
            className: 'visibility-value'
          }, props.value),
          column.header.label
        ),
        _react2.default.createElement('input', _extends({
          className: 'visibility-toggle',
          type: 'checkbox',
          id: key,
          checked: isVisible({ column: column }),
          onChange: function onChange() {
            return onToggleColumn({ column: column, columnIndex: columnIndex });
          }
        }, props.toggle))
      );
    })
  );
};
VisibilityToggles.propTypes = {
  /**
   * Example: \[
   *   {
   *     header: {
   *       label: 'Name'
   *     },
   *     visible: true
   *   },
   *   {
   *     header: {
   *       label: 'Age'
   *     },
   *     visible: false
   *   }
   * \]
   */
  columns: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  onToggleColumn: _propTypes2.default.func,
  isVisible: _propTypes2.default.func,
  /**
   * Props attached to different parts of the component.
   */
  props: _propTypes2.default.shape({
    container: _propTypes2.default.object,
    label: _propTypes2.default.object,
    value: _propTypes2.default.object,
    toggle: _propTypes2.default.object
  })
};
VisibilityToggles.defaultProps = {
  onToggleColumn: function onToggleColumn(_ref2) {
    var column = _ref2.column,
        columnIndex = _ref2.columnIndex;
  },
  isVisible: function isVisible(_ref3) {
    var column = _ref3.column;
    return column.visible;
  }
};

exports.default = VisibilityToggles;